import {VStore} from "../../store";
import puzzles from "../../utils/puzzles";
import {useEffect} from "react";

export default function VLogical() {
    const {width, depth, balkon, montageart, wandabstand} = VStore();

    useEffect(() => {
        puzzles.procedures?.setBalkon({balkon, montageart});
    }, [balkon])

    useEffect(() => {
        puzzles.procedures?.setMontageart({balkon, montageart});
    }, [montageart])

    useEffect(() => {
        puzzles.procedures?.setWandabstand(wandabstand);
    }, [wandabstand])

    useEffect(() => {
        puzzles.procedures?.setWidth(width);
    }, [width])

    useEffect(() => {
        puzzles.procedures?.setDepth(depth);
    }, [depth])
    return (<></>);
}
